import React, { useState, useEffect } from 'react';
import "../../../../public/styles/HomeInteriors/RecentWorksPage/ImagesContainer.scss";
import Modal from 'react-bootstrap/lib/Modal';
import Slider from "react-slick";
import apiManager from '../../../utils/apiManager';
import { espotAPI, imagePrefix } from '../../../../public/constants/constants';
import { isMobile, getWindowWidth } from '../../../utils/utilityManager';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ImagesContainer() {

  const [
    show,
    setShow,
  ] = useState(false);
    
  const [
    openTray,
    setOpenTray,
  ] = useState(false);
    
  const [
    imagesData,
    setImagesData,
  ] = useState([]);
    
  const [
    imagesDisplayed,
    setImagesDisplayed,
  ] = useState([]);
    
  const [
    displayLimit,
    setDisplayLimit,
  ] = useState(6);
    
  const [
    selectedObject,
    setSelectedObject,
  ] = useState(null);
    
  const [
    modalImageIndex,
    setModalImageIndex,
  ] = useState(0);

  const seeMoreHandler = () =>{
    const newDisplayArr = [...imagesDisplayed];
    const startIndex = displayLimit;
    setDisplayLimit(displayLimit+4);
    for (let index = startIndex; index < imagesData.length || index < displayLimit; index++){
      newDisplayArr.push(imagesData[index])      
    }
    setImagesDisplayed(newDisplayArr);
  }
  
  const modalOpenHandler = (idx) => {
    
    setShow(true);
    setOpenTray(false);
    setSelectedObject(imagesDisplayed[idx]);
    
    setSelectedImg(0);
  }

  const onCloseHandler = () => {
    setShow(false);
    setOpenTray(false);
    setSelectedObject(null);
    setModalImageIndex(0);
  }

  const decreaseIndex = () => {
    if(modalImageIndex == 0){
      setModalImageIndex(modalImageIndex);
      console.log(`idx: ${  modalImageIndex}`);
    }else{
      setModalImageIndex(modalImageIndex - 1);      
      console.log(`idx: ${  modalImageIndex}`);
    }
  }

  const setSelectedImg = (index) => {
    setModalImageIndex(index)
   
    selectedObject.images.map((data, i)=>{
      if(index != i){
        document.getElementById(`overlay-thumbnail-${  i}`).style.visibility="visible";
      }
      else{
        document.getElementById(`overlay-thumbnail-${  index}`).style.visibility="hidden";
      }
    })
  }

  const increaseIndex = () => {
    if(modalImageIndex == selectedObject.images.length -1){
      setModalImageIndex(modalImageIndex);       
      console.log(`idx: ${  modalImageIndex}`);
    }else{
      setModalImageIndex(modalImageIndex + 1);
      console.log(`idx: ${  modalImageIndex}`);
    }
  }



  const setDisplayArrData = (dataArray) =>{
    const displayArr = [];
    for (let index = 0; index < displayLimit || index < imagesData.length; index++) {
      displayArr.push(dataArray[index])
    }
    displayArr.length > 1 ? setImagesDisplayed(displayArr) : console.log("empty Arr");;
  }

  const getData = () => {
    apiManager
      .get(`${espotAPI  }GI_Recentworkpage`)
      .then(response => {
        const { data } = response || {};
        setImagesData(data.data.dataArray);
        setDisplayArrData(data.data.dataArray)
      }).catch(error => {
        console.log(error);
      })
  }


  useEffect(() => {
    getData();
  },[])
  const settings = {
    dots: false,
    lazyLoad: true,
    infinite: false,
    speed: 100,
    slidesToShow: isMobile() ? getWindowWidth() > 500 ? 3 : 2.5: 4.5,
    initialSlide: 0,
    prevArrow: false,
    nextArrow: false,
    autoplay: false,
    arrows: false,
    
  };
  return (
    <div className='main-container recent-works'>
      {
        !isMobile() ?
          <div className='title' style={{textAlign:"left", marginLeft:'5%', marginTop:'5%', color:'#337ab7'}}>
            <a href='/home-interiors' ><b>Home</b></a>  {`>`} Portfolio
          </div> :
                
          <div className='title' style={{textAlign:"left", marginLeft:'5%', marginTop:'5%', color:'#337ab7'}}>
            <a href='/home-interiors' ><b>Home</b></a>  {`>`} Portfolio <br></br>
            <h3 style={{color:'black'}}>Explore our recent projects</h3>
          </div>
      }

      <div className='image-grid'>
        {!!imagesDisplayed && imagesDisplayed.map((obj, index) => (
            
          <div key={index} onClick={() => modalOpenHandler(index)} className='thumbnail-container'>
            <img
              src={`${imagePrefix}${obj.thumbnail_img}`} 
            />
            <div className='overlay'><span>{obj.title}</span></div>
          </div>
        ))}
      </div>


      {imagesDisplayed.length < imagesData.length ? <div className='button-container'>
        <button onClick={seeMoreHandler}>
                SEE MORE
        </button>
      </div> : null}

      <Modal
        show={show}
        fullscreen="true"
        dialogClassName="custom"
        centered
      >
        <div className="close-btn-div">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={onCloseHandler}
          >
            <span aria-hidden="true">&#10005;</span>
          </button>
        </div>
        {modalImageIndex > 0 ? <div className='left-arrow'>
          <button 
            onClick={decreaseIndex}
          >
            <span>&#10094;</span>
          </button> 
        </div> : null}
        {selectedObject && modalImageIndex != selectedObject.images.length-1 ? <div className='right-arrow'>
          <button 
            onClick={increaseIndex}
          >
            <span>&#10095;</span>
          </button>
        </div> : null}
        <Modal.Body>
          <div className='modal-content'>
            <div className={`main-image${!openTray ? "" : "-shrinked"}`}>
              <img
                src={`${imagePrefix}${selectedObject != null ? selectedObject.images[modalImageIndex].src_img : ""}`}
              />
            </div>
            {isMobile()?<div className='tray-container'><button className={`tray-button-${!openTray? "up" : "down"}`} onClick={() => setOpenTray(!openTray)}>
                        &#10094;
            </button></div>: <button className={`tray-button-${!openTray? "up" : "down"}`} onClick={() => setOpenTray(!openTray)}>
                        &#10094;
            </button>}
                    
                    
            <div className={`tray${openTray? "": "-hide"}`}>
              <Slider {...settings} >
                {selectedObject && !!selectedObject.images && 
                                selectedObject.images.map((obj, index) => (
                                  <div key={index} onClick={() =>{ setSelectedImg(index)}} className='small-img-container'>
                                            
                                    <img 
                                      src={`${imagePrefix}${obj.src_img_rwd}`}
                                    />
                                    <div id={`overlay-thumbnail-${  index}`} className='overlay-thumbnail'>
                                      <span className='room'>{obj.title}</span>
                                    </div>
                                  </div>
                                ))
                }</Slider>
            </div>
                    
          </div>
        </Modal.Body>
      </Modal>


    </div>
  )
}

export default ImagesContainer
